import { API } from ".";

export const GET_NETWORK_ACCESS_LIST_REQUEST =
  "@@unit/GET_NETWORK_ACCESS_LIST_REQUEST";
export const GET_NETWORK_ACCESS_LIST_SUCCESS =
  "@@unit/GET_NETWORK_ACCESS_LIST_SUCCESS";
export const GET_NETWORK_ACCESS_LIST_FAILURE =
  "@@unit/GET_NETWORK_ACCESS_LIST_FAILURE";

export function getNetworkAccessList(id) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_NETWORK_ACCESS_LIST_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/unit/${id}/aplist`);
      dispatch({
        type: GET_NETWORK_ACCESS_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_NETWORK_ACCESS_LIST_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_NETWORK_SETTINGS_REQUEST =
  "@@unit/GET_NETWORK_SETTINGS_REQUEST";
export const GET_NETWORK_SETTINGS_SUCCESS =
  "@@unit/GET_NETWORK_SETTINGS_SUCCESS";
export const GET_NETWORK_SETTINGS_FAILURE =
  "@@unit/GET_NETWORK_SETTINGS_FAILURE";

export function getNetworkSettings(id) {
  if (!id) return;
  return async (dispatch) => {
    dispatch({
      type: GET_NETWORK_SETTINGS_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/unit/${id}/network`);
      dispatch({
        type: GET_NETWORK_SETTINGS_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_NETWORK_SETTINGS_FAILURE,
        payload: error,
      });
    }
  };
}

export const PUT_NETWORK_SETTINGS_REQUEST =
  "@@unit/PUT_NETWORK_SETTINGS_REQUEST";
export const PUT_NETWORK_SETTINGS_SUCCESS =
  "@@unit/PUT_NETWORK_SETTINGS_SUCCESS";
export const PUT_NETWORK_SETTINGS_FAILURE =
  "@@unit/PUT_NETWORK_SETTINGS_FAILURE";

export function updateNetworkSettings(id, data, callback) {
  if (!id) return;
  return async (dispatch) => {
    await dispatch(setCounter(1));
    dispatch({
      type: PUT_NETWORK_SETTINGS_REQUEST,
    });
    try {
      const init = {
        body: {
          settings: data,
        },
      };
      const response = await API.put("cmsAPI", `/unit/${id}/network`, init);
      dispatch({
        type: PUT_NETWORK_SETTINGS_SUCCESS,
        payload: response,
      });

      if (callback) {
        callback();
      }
    } catch (error) {
      dispatch({
        type: PUT_NETWORK_SETTINGS_FAILURE,
        payload: error,
      });
    }
  };
}

export const CLEAR_PREVIOUS_NETWORK_SETTINGS =
  "@@unit/CLEAR_PREVIOUS_NETWORK_SETTINGS";

export function clearPreviousNetworkSettings() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_PREVIOUS_NETWORK_SETTINGS,
    });
  };
}

export const SET_COUNTER = "@@unit/SET_COUNTER";

export function setCounter(value) {
  return async (dispatch) => {
    dispatch({
      type: SET_COUNTER,
      payload: value,
    });
  };
}
